import { getExt } from 'Cloud/Application/Editor/helpers';
import { EditorID } from 'Cloud/Application/Editor/types';
import { extInfo } from 'lib/extInfo';
import React, { useEffect, useState } from 'react';
import { MYOFFICE_ATTACHES_VIEWER, VIEWERS_CONFIG } from 'reactApp/appHelpers/configHelpers';
import { attachTextFormats } from 'reactApp/appHelpers/featuresHelpers';
import { R7_FOR_SHARING_ATTACHES } from 'reactApp/appHelpers/featuresHelpers/features/r7ForSharingAttach';
import { getItemNameWithoutExt } from 'reactApp/modules/file/utils';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { EStatus } from 'reactApp/sections/ErrorPage/ErrorPage.types';
import { ErrorPageBlock } from 'reactApp/sections/ErrorPage/ErrorPageBlock';
import { useLetterUrl } from 'reactApp/sections/LettersPage/useLetterUrl';
import { ReactViewerLetters } from 'reactApp/ui/ReactViewer/ReactViewerLetters';
import { noopVoid } from 'reactApp/utils/helpers';

const XRAY_CONFIG = {
    defaultParams: { p: 'sharing_attach_viewer' },
};

function encodeFileParam(url: string) {
    return url?.replace(/(file=)([^&]+)/, (_, prefix, filename) => {
        return prefix + encodeURIComponent(filename);
    });
}

const getFile = (ext: string, blobUrl: string, fileName: string | null, downloadUrl: string, id: string | null) => {
    const { kind, subKind } = extInfo.get(ext);

    return {
        ext,
        kind,
        subKind,
        isFolder: false,
        id: id || '',
        name: fileName || '',
        mtime: '',
        nameWithoutExt: fileName ? getItemNameWithoutExt(fileName, ext) : '',
        parent: '',
        size: 0,
        storage: EStorageType.embedded,
        thumbnails: {
            original: blobUrl || '',
        },
        url: {
            get: blobUrl || '',
            view: blobUrl || '',
            download: R7_FOR_SHARING_ATTACHES ? encodeFileParam(downloadUrl) : downloadUrl,
        },
        // легаси параметр, для r7 не требуется, но является обязательным
        content_type: 'r7content',
    };
};

const r7Viewer = VIEWERS_CONFIG.find(({ id }) => id === EditorID.R7);

const getMimeType = (ext: string) => {
    if (Array.isArray(attachTextFormats) && attachTextFormats.includes(ext.toLowerCase())) {
        return 'text/plain';
    }

    return extInfo.get(ext).mimeType ?? 'text/plain';
};

export const SharingAttachPage = () => {
    const url = decodeURIComponent(document.location.search.slice(4));
    const fileName = new URL(url).searchParams.get('file');
    const id = new URL(url).searchParams.get('id');
    const ext = getExt(fileName);
    const mimeType = getMimeType(ext);
    const { blobUrl, error } = useLetterUrl(url, mimeType);
    const [file, setFile] = useState<any | null>(null);

    useEffect(() => {
        if (blobUrl) {
            setFile(getFile(ext, blobUrl, fileName, url, id));
        }
    }, [ext, blobUrl, fileName]);

    if (error) {
        return <ErrorPageBlock status={EStatus.NOT_FOUND} />;
    }

    return (
        <ReactViewerLetters
            deleteFile={noopVoid}
            file={file}
            isActionOpen={false}
            isAuthorized={false}
            isMountedFolder={false}
            isPublicCopyEditable={false}
            itemCount={1}
            isNewbie={true}
            onClose={noopVoid}
            publishItemAction={noopVoid}
            selectItemIndexInArray={noopVoid}
            showEditorHeader={false}
            showSnackbar={noopVoid}
            showViewerHeader={true}
            isViewer={true}
            viewers={R7_FOR_SHARING_ATTACHES && r7Viewer ? [r7Viewer] : [MYOFFICE_ATTACHES_VIEWER]}
            toggleFavorite={noopVoid}
            sendSearchRadar={noopVoid}
            xrayConfig={XRAY_CONFIG}
            isViewerFileVerifiedByKaspersky={false}
            gaCategory="sharing_attach"
            itemStorage={EStorageType.viewerAttaches}
            sharingAttach
        />
    );
};
